import { ReactNode } from "react";
import { PopoverHover } from "components/PopoverHover";
import { Badge, StatusBadgeVariant } from "./style";

interface IProps {
  label: string;
  variant: StatusBadgeVariant;
  width?: string;
  popover?: ReactNode;
}

export function StatusBadge({ label, variant, width, popover }: IProps) {
  return (
    <PopoverHover popover={popover}>
      <Badge variant={variant} width={width}>
        {label}
      </Badge>
    </PopoverHover>
  );
}

export type { StatusBadgeVariant };
